require('./cookie')
import Vue from 'vue';

import {i18n} from "./i18n";
import Vue2TouchEvents from 'vue2-touch-events';
// App.vue
import App from './App.vue';
// Bulma
import Buefy from 'buefy'
// Global vue lodash
import _ from 'lodash'
import store from './store'
import router from './router'

import forms from './forms'
import AOS from 'aos';

i18n.locale = window.lang;

require('./validations')

Vue.use(Vue2TouchEvents)

Vue.component('app', App)

Vue.use(Buefy)


Vue.prototype._ = _;

Vue.mixin({
    methods: {
        removeSpace(string){
            return string.replace(/\s+/g, '').toLowerCase()
        },
    },
})



store.state.form.form = forms[window.form_js];
window.evo = new Vue({
    el: "#app",
    i18n,
    router,
    store,
})


function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}



docReady(function() {
    AOS.init({
        disable: 'mobile',
    })
});
